export default function onEnter(event, editor, next) {
  event.preventDefault();

  if (event.ctrlKey) {
    return false;
  } else if (event.altKey) {
    return editor.addTableRowBelow();
  } else {
    return editor.command('insertLineBreak');
  }
}